// @flow
import messages from '../../../../messages';

const { filtersAny } = messages;

export const addDefaulAndFacetArrayToObject = (facetsArray: Array<Object> = [], intl: Object) => {
  const obj = {
    '': intl.formatMessage(filtersAny),
  };
  facetsArray.forEach(facet => {
    obj[facet.value] = facet.value;
  });
  return obj;
};



// WEBPACK FOOTER //
// ./app/Serp/components/Filters/shared/utils/addDefaulAndFacetArrayToObject.js